import { render, staticRenderFns } from "./DataAlerts.vue?vue&type=template&id=9c638ab0&scoped=true&"
import script from "./DataAlerts.vue?vue&type=script&lang=js&"
export * from "./DataAlerts.vue?vue&type=script&lang=js&"
import style0 from "./DataAlerts.vue?vue&type=style&index=0&id=9c638ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c638ab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
